import React, { useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { CoverScreen } from '../components/auditoria/CoverScreen';
import { QuizScreen } from '../components/auditoria/QuizScreen';
import { ResultsScreen } from '../components/auditoria/ResultsScreen';
type Screen = 'cover' | 'quiz' | 'results';
export function AuditoriaPage() {
  const [screen, setScreen] = useState<Screen>('cover');
  const [answers, setAnswers] = useState<(boolean | null)[]>(new Array(10).fill(null));
  const handleStart = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    setScreen('quiz');
  };
  const handleComplete = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    setScreen('results');
  };
  const handleReset = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    setAnswers(new Array(10).fill(null));
    setScreen('cover');
  };
  return <div className="min-h-screen bg-[var(--black)] text-[var(--white)] font-sans selection:bg-[var(--gold)] selection:text-black" data-id="element-416">
      <AnimatePresence mode="wait" data-id="element-417">
        {screen === 'cover' && <CoverScreen key="cover" onStart={handleStart} data-id="element-418" />}
        {screen === 'quiz' && <QuizScreen key="quiz" answers={answers} setAnswers={setAnswers} onComplete={handleComplete} data-id="element-419" />}
        {screen === 'results' && <ResultsScreen key="results" answers={answers} onReset={handleReset} data-id="element-420" />}
      </AnimatePresence>
    </div>;
}